// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"f63248ee","303":"d0b59db3","552":"7b8e81dd","618":"7b8e81dd","726":"f63248ee","912":"f63248ee"}[chunkId] + ".chunk.css";
};